__turbopack_context__.v({
  "titleContainer": "SectionTitle-module__8ccDeW__titleContainer",
  "titleText": "SectionTitle-module__8ccDeW__titleText",
});
